import _ from 'lodash'

// eslint-disable-next-line
export const getGraphConfig = (dataProvider, minValue, translates) => {
    return {
        type: 'radar',
        theme: 'none',
        dataProvider,
        valueAxes: [
            {
                axisTitleOffset: 10,
                gridType: 'circles',
                axisAlpha: 0.15,
                minimum: minValue < 0 ? minValue - 100 : minValue * -1 - 100,
            },
        ],
        // Guides are only possible if maximum of the graph is set (toValue propery problem)
        // guides: [
        //     {
        //         angle: 270,
        //         tickLength: 0,
        //         toAngle: 353.077,
        //         fillAlpha: 0.75,
        //         fillColor: '#EAF7FC',
        //         value: 0,
        //         toValue: 300,
        //     },
        //     {
        //         angle: -6.923,
        //         tickLength: 0,
        //         toAngle: 76.153,
        //         fillAlpha: 0.75,
        //         fillColor: '#F8FAEA',
        //         value: 0,
        //         toValue: 300,
        //     },
        //     {
        //         angle: 76.16,
        //         tickLength: 0,
        //         toAngle: 186.923,
        //         fillAlpha: 0.75,
        //         fillColor: '#FBE5E5',
        //         value: 0,
        //         toValue: 300,
        //     },
        //     {
        //         angle: 186.923,
        //         tickLength: 0,
        //         toAngle: 270,
        //         fillAlpha: 0.75,
        //         fillColor: '#FFF9E7',
        //         value: 0,
        //         toValue: 300,
        //     },
        // ],
        graphs: [
            // {
            //     bullet: 'round',
            //     bulletSize: 10,
            //     bulletColor: '#ffffff',
            //     bulletBorderColor: '#29ABE2',
            //     bulletBorderAlpha: 1,
            //     bulletBorderThickness: 1,
            //     lineThickness: 1,
            //     valueField: 'firm',
            //     lineColor: '#29ABE2',
            //     fillColors: '#29ABE2',
            //     fillAlphas: 0.1,
            //     balloonText: '[[type]]: [[value]]',
            //     title: _.get(translates, 'firmEvolution'),
            // },
            {
                bullet: 'round',
                bulletSize: 10,
                bulletColor: '#ffffff',
                bulletBorderColor: '#29ABE2',
                bulletBorderAlpha: 1,
                bulletBorderThickness: 1,
                lineThickness: 1,
                lineColor: '#29ABE2',
                fillColors: '#29ABE2',
                fillAlphas: 0.1,
                valueField: 'firmVersusSector',
                balloonText: '[[type]]: [[value]]%',
                title: `${_.get(translates, 'firmVersusSector')}`,
            },
            {
                bullet: 'round',
                bulletSize: 10,
                bulletColor: '#ffffff',
                bulletBorderColor: '#662D91',
                bulletBorderAlpha: 1,
                bulletBorderThickness: 1,
                lineThickness: 1,
                lineColor: '#662D91',
                // fillColors: '#662D91',
                fillAlphas: 0,
                valueField: 'sectorBasePercentage',
                showBalloon: false,
                title: `${_.get(translates, 'sectorAverage')}`,
            },
        ],
        legend: {
            position: 'absolute',
            top: 0,
            left: 0,
            maxColumns: 1,
            markerSize: 12,
        },
        creditsPosition: 'bottom-right',
        categoryField: 'type',
    }
}
